var map = {
	"./attacks_campaigns.svg": 14436,
	"./cyber_incident.svg": 12281,
	"./demonstrations.svg": 92329,
	"./diplomatic_tensions.svg": 80939,
	"./disinformation.svg": 98011,
	"./economic_indicators.svg": 95391,
	"./elections.svg": 91139,
	"./emerging_technology.svg": 2499,
	"./emerging_threats.svg": 78829,
	"./exploit_code.svg": 1766,
	"./malware_tools_analysis.svg": 93011,
	"./military.svg": 79548,
	"./natural_hazards.svg": 25714,
	"./physical_threat.svg": 50685,
	"./policy_compliance.svg": 95103,
	"./political_meeting.svg": 54088,
	"./product_updates.svg": 2801,
	"./sanctions.svg": 23081,
	"./social_event.svg": 797,
	"./threat_disruption.svg": 93371,
	"./trade_agreements.svg": 62803,
	"./trend_report.svg": 80343,
	"./underground_activity.svg": 41536,
	"./vulnerability.svg": 33517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65176;